/* eslint-disable max-len */
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { object, array, func, number, bool, string } from "prop-types";
import get from "lodash/get";
import { Link, LoadMoreCollectionStories } from "@quintype/components";

import More from "../../atoms/More";
import CustomStoryCard6 from "../../molecules/CustomStoryCard6";
import Headline from "../../atoms/Headline";

import { getSlug, getCollectionName } from "../../utils/utils";
import { staticTexts } from "../../utils/Translate";

import "./fourColStoriesWithLoadMore.m.css";

const NO_OF_STORIES_TO_LOAD = 8;

const FourColStoriesWithLoadMore = ({ collection, sections, publisherAttributes, domainSlug }) => {
  const storiesToLoad = get(collection, ["associated-metadata", "number_of_stories_inside_collection_to_show"], 4);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    setIsMobile(global.deviceWidth < 875);
  }, []);

  const showCollectionName = get(collection, ["associated-metadata", "show_collection_name_website"], true);
  const navigateTo = get(collection, ["associated-metadata", "navigate_to"], "");
  const navigateToTitle = get(collection, ["associated-metadata", "navigate_to_title"], "");

  const collectionName = getCollectionName(collection, navigateToTitle);
  const slug = getSlug(collection, sections, domainSlug, navigateTo);
  const stories = collection.items
    .filter((item) => item.type === "story")
    .map(({ story }) => story)
    .slice(0, storiesToLoad);

  const headlineStyle = `${publisherAttributes.lang}-collection-title`;

  if (!stories.length) {
    return null;
  }

  return (
    <div styleName={`base ${publisherAttributes.lang}-base`}>
      {showCollectionName && (
        <Link href={slug}>
          <Headline
            text={collectionName}
            headerLevel={2}
            headlineDesign="witharrow"
            className="collection-name-arrow"
            styleName={headlineStyle}
          />
        </Link>
      )}

      <LoadMoreCollectionStories
        template={(e) => MoreCollectionStories(e, isMobile, publisherAttributes)}
        collectionSlug={collection.slug}
        data={{ stories: stories }}
        params={{ "item-type": "story" }}
        numStoriesToLoad={NO_OF_STORIES_TO_LOAD}
      />
    </div>
  );
};

function MoreCollectionStories({ stories, onLoadMore, noMoreStories }, isMobile, publisherAttributes) {
  return (
    <div>
      <div styleName="wrapper">
        {stories.map((story, index) => (
          <CustomStoryCard6
            key={index}
            story={story}
            imageType={isMobile ? "image4x3" : "image16x9"}
            aspectRatio={isMobile ? [4, 3] : [16, 9]}
            isStoryMetaData={!isMobile}
            src="four-col-stories-with-load"
          />
        ))}
      </div>
      <div>
        {!noMoreStories ? (
          <div styleName={`load-more ${publisherAttributes.lang === "en" ? "en-load-more" : ""}`}>
            <More type="load-more" text={staticTexts(publisherAttributes.lang).loadMore} onClick={onLoadMore} />
          </div>
        ) : null}
      </div>
    </div>
  );
}

FourColStoriesWithLoadMore.propTypes = {
  collection: object,
  story: object,
  sections: array,
  publisherAttributes: object,
  domainSlug: string,
};

MoreCollectionStories.propTypes = {
  stories: array.isRequired,
  onLoadMore: func,
  noMoreStories: number,
  loading: bool,
  isMobile: bool,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  sections: get(state, ["qt", "config", "sections"], []),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], ""),
});

export default connect(mapStateToProps)(FourColStoriesWithLoadMore);
